import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Button } from 'antd'
import { EasyIcon, ListPropsContext } from 'src/components'
import { listStore } from 'src/stores'

type Props = {
  config: ButtonConfig
}

const RefreshBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleRefresh = () => {
    table?.reload()
  }

  const { LABEL, ICON } = props.config
  return <Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='SyncOutlined' />} onClick={handleRefresh}>{LABEL}</Button>
}

export default RefreshBtn